module.exports = __webpack_public_path__ + "static/img/case_tab_09.c462f7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_09.png
// module id = hEt9
// module chunks = 34